import { SET_BUCKET_DOMAIN, SET_BUCKET_DOMAIN_TOKEN } from './mutationTypes';

export default {
  update_operation_list(state, payload) {
    state.operationList = payload;
  },
  update_permission_list(state, payload) {
    state.permissionList = payload;
  },
  updateLoginData(state, payload) {
    state.loginData = payload;
  },
  updateActiveIndex(state, payload) {
        // 更新状态的逻辑
        state.activeIndex = payload;
      },
  [SET_BUCKET_DOMAIN](state, payload) {
	console.log(payload,"SJSJ")  
    state.imgDomain = payload;
  },
  [SET_BUCKET_DOMAIN_TOKEN](state, payload) {
    state.bucket_domain_token = payload;
  }
};